import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CustomerConst } from '@app/constants/customer-const';
import { MethodsHelper } from '@app/helpers/methods.helper';
import { CustomerFilter } from '@app/models/customer-filter';

declare var $: any;

@Component({
    selector: 'app-customer-advanced-search-form',
    templateUrl: './advanced-search-form.component.html',
    styleUrls: ['./advanced-search-form.component.css'],
    standalone: false
})
export class AdvancedSearchFromComponent implements OnInit {

  customerFilter: CustomerFilter;

  @Input() displaySearchDialog: boolean;
  @Output() onSubmit = new EventEmitter<CustomerFilter>();
  @Output() onCancel = new EventEmitter();

  @ViewChild('form') formStep4: any;

  customerBirthDate: Date;
  submittedForm: boolean = false;

  selectedStatus: any;
  yearRange: string;
  emailMessage: string;
  
  statuses = [
    { 'value': 'ACTIVE', 'label': 'Active' },
    { 'value': 'INACTIVE', 'label': 'Inactive' },
    { 'value': 'WAITING_FOR_APPROVAL', 'label': 'Waiting for Approval' }
  ];
  genders = [
    { 'value': 'FEMALE', 'label': 'Female' },
    { 'value': 'MALE', 'label': 'Male' },
    { 'value': 'OTHER', 'label': 'Other' }
  ];

  constructor() { }

  ngOnInit() {
    this.yearRange = MethodsHelper.getYearRange(-1);
    const savedFilter = localStorage.getItem('customerAdvancedSearch');
    if (savedFilter) {
      this.customerFilter = Object.assign(new CustomerFilter(), JSON.parse(savedFilter));
    } else {
      this.customerFilter = new CustomerFilter();
    }
  }

  cancelSearch() {
    localStorage.removeItem('customerAdvancedSearch');
    this.onCancel.emit();
  }

  validateForm() {
    if (this.formStep4.form)
      return this.formStep4.form.valid;
    return false;
  }

  changeStatus(status) {
    this.customerFilter.status = status.value;
  }

  changeBirthDate($event) {
    this.customerFilter.birthDate = MethodsHelper.convertDateToString($event);
  }

  onSearch() {
    this.submittedForm = true;
    if (this.validateForm()) {
      localStorage.setItem('customerAdvancedSearch', JSON.stringify(this.customerFilter));

      const filterToEmit = { ...this.customerFilter };
      if (filterToEmit.idCard) {
        filterToEmit.documentType = CustomerConst.IDENTITY_TYPE.ID_CARD;
        filterToEmit.passportSerialNumber = filterToEmit.idCard;
        delete filterToEmit.idCard;
        delete filterToEmit.socialSecurityNumber;
      } else if (filterToEmit.socialSecurityNumber) {
        filterToEmit.documentType = CustomerConst.IDENTITY_TYPE.SSC;
        filterToEmit.passportSerialNumber = filterToEmit.socialSecurityNumber;
        delete filterToEmit.idCard;
        delete filterToEmit.socialSecurityNumber;
      } else if (filterToEmit.passportSerialNumber) {
        delete filterToEmit.documentType;
        delete filterToEmit.idCard;
        delete filterToEmit.socialSecurityNumber;
      }

      this.onSubmit.emit(filterToEmit);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ?? event.keyCode;
    return !(charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
  }

  allowAlphanumericSpace(event) {
    return MethodsHelper.onlyAlphanumericSpace(event);
  }

  isValidEmail() {
    const email = this.customerFilter.email;
    if (!email) {
      this.emailMessage = '';
    } else {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      this.emailMessage = emailRegex.test(email) ? '' : 'Invalid email format';
    }
  }

}
